import { api } from "../api";
import { Role } from "../../types/role.types";

export const roleService = api.injectEndpoints({
  endpoints: (build) => ({
    getAllRoles: build.query<Array<Role>, string>({
      query: () => ({
        url: "/role/all-roles"
      })
    }),
  })
});

export const {
  useGetAllRolesQuery
} = roleService;